export const GET_Cloth_LOADING = "cloth/get/laoding";
export const GET_Cloth_SUCCESS = "cloth/get/success";
export const GET_Cloth_ERROR = "cloth/get/error";

// add item  
export const ADD_Cloth_LOADING = "cloth/add/laoding";
export const ADD_ClothT_SUCCESS = "cloth/add/success";
export const ADD_Cloth_ERROR = "cloth/add/error";

// update  
export const UPDATE_Cloth_LOADING = "cloth/update/laoding";
export const UPDATE_Cloth_SUCCESS = "cloth/update/success";
export const UPDATE_ClothS_ERROR = "cloth/update/error";

// REMOVE  
export const REMOVE_Cloth_LOADING = "cloth/remove/laoding";
export const REMOVE_Cloth_SUCCESS = "cloth/remove/success";
export const REMOVE_Cloth_ERROR = "cloth/remove/error";

export const SORT_CLOTHES="CLOTHES/sort"